import React from "react";
import styles from "./cards.module.scss";
import { useTranslation } from "lib/i18n/use-translation";
import { Button } from "components/ui";
import { SelectInputOption } from "../../api/types";
import { Input } from "reactstrap";
import clsx from "clsx";

interface SessionFeedbackSelectButtonCardProps {
  title: string;
  onClick: (responseId: string, value: string) => void;
  options: SelectInputOption[];
  onChange?: (value: string) => void;
  shouldShowButtonLabels?: boolean;
  type?: "StartStep" | "RangeStep" | "EndStep";
  response?: any;
}

const SessionFeedbackSelectButtonCard: React.FC<
  SessionFeedbackSelectButtonCardProps
> = ({
  title,
  onClick,
  options,
  type,
  onChange,
  shouldShowButtonLabels,
  response,
}) => {
  const { t } = useTranslation(["feedback"]);
  let shouldShowTwoRows = false;
  const imageClass = shouldShowButtonLabels
    ? styles["select-option-image"]
    : "";

  if (type === "RangeStep" && options.length > 5 && options.length <= 11) {
    shouldShowTwoRows = true;
  }
  return (
    <div className={styles["session-feedback-select-button-card"]}>
      <p
        className={styles["session-feedback-select-button-card-title"]}
        dangerouslySetInnerHTML={{ __html: title }}
      />

      {type === "EndStep" && (
        <div className={styles["feedback-by-student-end-step"]}>
          <Input
            width={384}
            height={111}
            type="textarea"
            className={styles["feedback-by-student-end-step-input"]}
            placeholder={t("feedback:steps.feedback.placeholder")}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            value={response?.value || ""}
            maxLength={500}
          />
        </div>
      )}

      {!shouldShowTwoRows && type !== "EndStep" && (
        <div className={styles["session-feedback-select-button-card-options"]}>
          {Object.values(options).map((option) => (
            <div
              key={option.id}
              className={styles["session-feedback-select-button-card-option"]}
            >
              <Button
                key={option.id}
                variant="enclosed-secondary"
                className={clsx(
                  styles[
                    `${
                      response?.value === option.value
                        ? "select-option-button-active"
                        : "select-option-button"
                    }`
                  ],
                  imageClass
                )}
                onClick={() => {
                  onClick(option.id, option.value);
                }}
              >
                {shouldShowButtonLabels ? option.imageUrl : option.label}
              </Button>
              {shouldShowButtonLabels && (
                <p
                  className={
                    styles[
                      `${
                        response?.value === option.value
                          ? "session-feedback-select-button-card-option-label-active"
                          : "session-feedback-select-button-card-option-label"
                      }`
                    ]
                  }
                >
                  {option.label}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
      {shouldShowTwoRows && type !== "EndStep" && (
        <>
          <div
            className={
              styles["session-feedback-select-button-card-multiple-rows"]
            }
          >
            {Object.values(options).map((option) => (
              <div
                key={option.id}
                className={styles["session-feedback-select-button-card-option"]}
              >
                <Button
                  key={option.id}
                  variant="enclosed-secondary"
                  className={clsx(
                    styles[
                      `${
                        response?.value === option.value
                          ? "select-option-button-2-active"
                          : "select-option-button-2"
                      }`
                    ],
                    imageClass
                  )}
                  onClick={() => {
                    onClick(option.id, option.value);
                  }}
                >
                  {shouldShowButtonLabels ? option.imageUrl : option.label}
                </Button>
              </div>
            ))}
          </div>
          <div className={styles["session-feedback-select-button-card-range"]}>
            <p>{t("feedback:rangeScale.agreeMin")}</p>
            <p>{t("feedback:rangeScale.agreeMax")}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default SessionFeedbackSelectButtonCard;
